module.exports = __webpack_public_path__ + "img/chuneng3.bab0f571.png";